module.exports = __webpack_public_path__ + "static/media/garcon.cbe7e932.svg";